import { render, staticRenderFns } from "./OptionsDropdown.vue?vue&type=template&id=b94b5d60&scoped=true"
import script from "./OptionsDropdown.vue?vue&type=script&lang=js"
export * from "./OptionsDropdown.vue?vue&type=script&lang=js"
import style0 from "./OptionsDropdown.vue?vue&type=style&index=0&id=b94b5d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94b5d60",
  null
  
)

export default component.exports